function bindaddFlavour(){
  $('.open-drawer-flavour').off('click');
  $('.open-drawer-flavour').click(function() {
    var drawer = $('#mrk-flavours-drawer');
    drawer.attr('open', true);
    $(document).addClass('lock-all');
    window.index = $(this).attr('index');
    window.mrkOpenedItem = $(this); // Save the clicked item for later use
  });
}
function bindClose() {
  $('.mrk-item-remove-btn').off('click');
  $('.mrk-item-remove-btn').click(function(){
    var properties = $(this).parents('.mrk-filled-item-data').find('.mrk-hidden-data').html();
    if($(this).parents('.mrk-filled-item-data').hasClass('mrk-addon-item-filled')){
      $(this).parents('.mrk-filled-item-data').remove();
    }
    window.index = $(this).attr('index');
    var index = window.index;
    var emptyItemHtml = $('#empty-item').html();
    var emptyItem = $(emptyItemHtml);
    emptyItem.find('.mrk-item-count').text(`Flavour ${index}`);
    emptyItem.attr('index', index);
    emptyItem.find('.mrk-hidden-data').html(properties);
    emptyItem.find('input').val('');
    $(this).parents('.mrk-filled-item-data').replaceWith(emptyItem.prop('outerHTML'));
    bindaddFlavour();
  });
}
$(document).ready(function() {
    // Step 3: On click of .mrk-flavour-item, get its data and update the offcanvas content
    $(document).on('click', '.mrk-flavour-item', function() {
      var clickedItem = $(this);
  
      // Get the data from the clicked item
      var image = clickedItem.attr('image');
      var title = clickedItem.attr('title');
      if($('.product-form__input input:checked').val().includes('12')){
        var selected_item = clickedItem.attr('mrk-12-pack');
      }else{
        var selected_item = clickedItem.attr('mrk-30-pack');
      }
      var index = window.index;
      if(index == 'none'){
        index = $('.mrk-filled-item-data').length + 1;
      }
      var properties = $(window.mrkOpenedItem).find('.mrk-hidden-data');
      // Get the HTML from the template and create a jQuery object
      var filledItemHtml = $('#filled-item').html();
      var filledItem = $(filledItemHtml);
      var formId = properties.find('[name="itemId"]').attr('mrk-form');
      
      // Update the offcanvas cart with the clicked item's data
      filledItem.find('.mrk-item-image').attr('src', image);
      filledItem.find('.mrk-item-title').text(title);
      filledItem.find('.mrk-item-remove-btn').attr('index', index);
      filledItem.attr('index', index);
      filledItem.find('.mrk-hidden-data').html(properties.html());
      filledItem.find('.mrk-hidden-data input').val(selected_item);
      $('[name="id"]').prop('disabled', true);
      if (window.mrkOpenedItem) {
          $(window.mrkOpenedItem).replaceWith(filledItem.prop('outerHTML'));
          var drawer = $('#mrk-flavours-drawer');
          drawer.removeAttr('open');
          $(document).removeClass('lock-all');
          bindClose();
      }
  });
  bindClose();
  bindaddFlavour();
  $(window).on('cart:updateddd', async function(e) {
    var cart = e.detail.cart;
    console.log(cart);

    var variantIdsToRemove = [];
    var allVariantIds = new Set(cart.items.map(item => item.variant_id.toString()));

    // Loop through the items in the cart
    cart.items.forEach(item => {
        // Check if the item has a _parentVariant property and if it's not in allVariantIds
        if (item.properties && item.properties._parentVariant && item.properties._freeItem && !allVariantIds.has(item.properties._parentVariant.toString())) {
            variantIdsToRemove.push(item.variant_id.toString());  // Add the current item's variant_id to the removal list
        }
    });

    console.log(variantIdsToRemove);
    if (variantIdsToRemove.length > 0) {
      // Construct the items array for the removal request
      let updates = variantIdsToRemove.reduce((obj, id) => {
          obj[id] = 0;
          return obj;
      }, {});

      // Make a single request to Shopify to remove the items
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js',{
          body: JSON.stringify({
              updates,
              sections: ["mini-cart"]  // Include the sections parameter with "mini-cart"
          }),
          credentials: "same-origin",
          method: "POST",
          headers: {
              "Content-Type": "application/json"
          }
      });
      const cartContent = await response.json();

      // Dispatch event to refresh the cart UI
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
              cart: cartContent,
              replacementDelay: 600 // Since quantity is set to 0 for removal
          }
      }));
  }
});


  $(window).on('variantChange', function() {
      const url = new URL(window.location);
      const sectionId= window.productSection;
      url.searchParams.append('section_id', sectionId);
      const urlString = url.toString();
      console.log('variant_changed:', urlString);
      fetchInfluencerSection(urlString);
  });
  $('#mrk-flavours-drawer .drawer__close-button, #mrk-flavours-drawer .drawer__overlay').click(function (e) { 
    e.preventDefault();
    var drawer = $('#mrk-flavours-drawer');
    drawer.removeAttr('open');
    $(document).removeClass('lock-all');
  });
  
  function fetchInfluencerSection(variantUrl) {
      $.ajax({
          url: variantUrl,
          cache: true,
          success: function(data) {
              const flavoursSelection = $(data).find('.mrk-flavours-selection').html();
              $('.mrk-flavours-selection').html(flavoursSelection);
              bindaddFlavour();
          },
          error: function(xhr, status, error) {
              throw new Error(xhr.status);
          }
      });
  }

});
